<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><img alt="images" src="images/act.jpg"/>CT ONE</h1>
<h1 class="h1title"><img alt="images" src="images/left.jpg"/> <span class="txit">Ten Years Later</span> <img alt="images" src="images/right.jpg"/></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?799eaaea